import React, { useEffect, useState } from 'react'
import './CustomLightbox.css';
import ReactDOM from 'react-dom';
import { API_BASE_URL } from '../../utils/apiConfig';

const CustomLightbox = ({ images }) => {
    
      const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => setIsOpen(false);

  const prevImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  // ESC key support
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') prevImage(e);
      if (e.key === 'ArrowRight') nextImage(e);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  });

  return (
    <div className="project-detail-screenshots glass-card">
      <h4>Screenshot:</h4>
      <div className="project-detail-screenshot-grid">
        {images.map((src, index) => (
          <img
            key={index}
            src={`${API_BASE_URL}/images/${src}`}
            alt={`Screenshot ${index + 1}`}
            onClick={() => openLightbox(index)}
            className="screenshot-thumb"
          />
        ))}
      </div>

      {isOpen &&
        ReactDOM.createPortal(
          <div className="custom-lightbox-body" onClick={closeLightbox}>
            <button className="lightbox-close" onClick={closeLightbox}>✕</button>
            <button className="lightbox-prev" onClick={prevImage}>‹</button>
            <img
              src={images[currentIndex]}
              alt={`Screenshot ${currentIndex + 1}`}
              className="lightbox-image"
            />
            <button className="lightbox-next" onClick={nextImage}>›</button>
            <div className="lightbox-caption">
              Screenshot {currentIndex + 1} of {images.length}
            </div>
          </div>,
          document.body
        )}
    </div>
  );

}

export default CustomLightbox